import { TextCaption } from '@carboncopyco/ui';

export interface ImageDetailsProps {
  children: React.ReactNode;
}

export interface ImageNameProps {
  name: string;
}

export interface ImageMetadataProps {
  format: string;
  width: number;
  height: number;
}

export const ImageDetails = ({ children }: ImageDetailsProps) => {
  return (
    <div className="flex flex-col justify-center items-start gap-1.5 overflow-hidden">
      {children}
    </div>
  );
};

const ImageName = ({ name }: ImageNameProps) => (
  <div className="flex w-full">
    <TextCaption
      label={name}
      ellipsis
    />
  </div>
);

const ImageMetadata = ({ format, width, height }: ImageMetadataProps) => (
  <TextCaption label={`${format.toUpperCase()}: ${width}×${height}`} />
);

ImageDetails.Name = ImageName;
ImageDetails.Metadata = ImageMetadata;
